import StagingRecorderContainer from "./StagingRecorderContainer";

export default StagingRecorderContainer;